PJQ.views.commitments.CommitmentEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-commitment-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        fromChangeRequest: null,
        commitmentType: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .copy-to-billto': 'copyToHelper',
        'click .copy-to-shipto': 'copyToHelper',
        'click .btn-new-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-new-invoice': 'newInvoice',
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .btn-delete': 'deleteCommitment',
        'click .btn-close': 'close',
        'change .input-coi-required': 'renderCOIApproval',
        'change .input-w9-required': 'renderW9Approval',
        'change .input-lien-waiver-required': 'renderLienWaiverApproval',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveCommitment',
        'click .btn-submit-for-review': 'submitForReview',
        'click .btn-sign-submit': 'signAndSubmit',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportCommitment',
        'click .btn-email': 'email',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchCommitmentFieldSettings();
        this.terms = await this.options.project.fetchCommitmentTerms();
        this.customFields = await this.options.project.fetchCommitmentCustomFields();
        this.settings = await this.options.project.fetchCommitmentSettings();

        this.invoiceSettings = null;
        if (this.options.project.hasPermission('payableInvoices.canView')) {
            this.invoiceSettings = await this.options.project.fetchPayableInvoiceSettings();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.uploadCustomFields = _.filter(this.customFields.models, function (model) {
            return model.get('fieldTypeId') === 13;
        }, this);

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.commitments.Commitment({
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                contractedContact: this.options.contractedContact ?? null,
                commitmentType: this.options.commitmentType ? this.options.commitmentType : PJQ.constants.commitments.commitmentType.PURCHASE_ORDER,
                title: this.options.fromChangeRequest ? this.options.fromChangeRequest.get('title') : '',
                description: this.options.fromChangeRequest ? this.options.fromChangeRequest.get('description') : '',
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.commitments.commitmentStatus.DRAFT,
                billTo: {},
                shipTo: {},
                lineItems: this.options.lineItems,
                customFieldValues: customFieldValues
            });
        }

        if (this.model.isNew()) {
            this.model.set({
                defaultWorkRetainagePercent: this.settings.get('defaultWorkRetainagePercent'),
                defaultMaterialRetainagePercent: this.settings.get('defaultMaterialRetainagePercent'),
            })
        }

        if (!this.model.isNew() && this.options.fetch !== false) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.hasEditPermission = this.options.project.hasPermission('commitments.canEdit');
        this.options.canEdit = this.options.hasEditPermission;
        this.options.canEditDates = this.options.hasEditPermission;
        this.options.canUploadAttachments = this.options.canEdit;
        this.options.canEditLineItems = this.options.project.hasPermission('commitments.canEditLineItems');
        this.options.canViewChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canView');
        this.options.canAddChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.options.canViewInvoices = this.options.project.hasPermission('payableInvoices.canView');
        this.options.canAddInvoices = this.options.project.hasPermission('payableInvoices.canAdd');
        this.options.isAdmin = this.options.project.hasPermission('commitments.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.commitments.commitmentStatus.APPROVED ||
            status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE) {
            this.options.canAddChangeOrders = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canAdd');
            this.options.canAddInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canAdd');
        } else {
            this.options.canAddChangeOrders = false
            this.options.canAddInvoices = false;
        }

        let isContractedContact = (PJQ.app.session.contact && PJQ.app.session.contact.id === this.model.get('contractedContactId')) ||
            (this.model.contractedContact != null && PJQ.app.session.user.id === this.model.contractedContact.get('userId'));
        this.options.isSubmitting = isContractedContact && (status === PJQ.constants.commitments.commitmentStatus.DRAFT
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID
            || status === PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE);

        if (status === PJQ.constants.commitments.commitmentStatus.DRAFT) {
            this.options.canEdit = isContractedContact || this.options.hasEditPermission;
            this.options.canEditDates = this.options.canEdit;
            this.options.canUploadAttachments = this.options.canEdit;
            this.options.canEditLineItems = PJQ.app.session.project.hasPermission('commitments.canEditLineItems');
        } else if (status === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID) {
            this.options.canUploadAttachments = isContractedContact || this.options.canEdit;
            this.options.canEditLineItems = isContractedContact || PJQ.app.session.project.hasPermission('commitments.canEditLineItems');
        } else if (status === PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE) {
            this.options.canUploadAttachments = isContractedContact || this.options.canEdit;
            this.options.canEditLineItems = this.options.isAdmin;
        } else if (status === PJQ.constants.commitments.commitmentStatus.APPROVED
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED
            || status === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_VOID
            || status === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED) {
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else if (status === PJQ.constants.commitments.commitmentStatus.SUBMITTED) {
            this.options.canEditLineItems = false;
        }

        if (this.model.invoices.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
                this.options.isSubmitting = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canAddChangeOrders: this.options.canAddChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            canAddInvoices: this.options.canAddInvoices,
            isSubmitting: this.options.isSubmitting,
            canEdit: this.options.canEdit,
            canUploadAttachments: this.options.canUploadAttachments,
            canEditLineItems: this.options.canEditLineItems,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            terms: this.terms,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            uploadCustomFields: this.uploadCustomFields,
            hasPendingInvoice: this.model && this.model.invoices.models.length > 0 && null != _.find(this.model.invoices.models, (invoice) => {
                return invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED
                    && invoice.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE;
            })
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        window.testModel = this.model;

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if (markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))) {
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if (lineItem) {
                    if (lineItem.get('id') > 0) {
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();

        this.renderLineItems();
        if (!this.model.isNew()) {
            if (this.options.canViewChangeOrders) {
                this.renderChangeOrders();
            }
            if (this.options.canViewInvoices) {
                this.renderInvoices();
                this.renderPayments();
            }
        }
        this.renderMarkups();
        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-change-orders').text(_.size(this.model.changeOrders.models));
        this.$('.count-invoices').text(_.size(this.model.invoices.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'C_General',
        LINEITEMS: 'C_LineItems',
        CHANGEORDERS: 'C_ChangeOrders',
        INVOICES: 'C_Invoices',
        PAYMENTS: 'C_Payments',
        MARKUPS: 'C_Markups',
        HISTORY: 'C_History'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
            case this.views.CHANGEORDERS:
            case this.views.INVOICES:
            case this.views.PAYMENTS:
            case this.views.MARKUPS:
                // do nothing
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$('.general-pane'), this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = [];
        _.each(PJQ.constants.commitments.commitmentStatus, (st) => {
            if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT
                && (st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
                    || st === PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED)) {
                return;
            } else if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER
                && (st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED
                    || st === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_VOID)) {
                return;
            }

            choices.push({
                id: st,
                name: PJQ.constants.commitments.commitmentStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            });
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Commitment saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    })
                } else {
                    this.render();
                }
            }
        });

        let defaultTerm = _.find(this.terms.models, function (model) {
            return model.get('isDefault');
        }, this);
        if (this.model.isNew() && defaultTerm != null && defaultTerm.id > 0) {
            this.model.set('termsId', defaultTerm.id);
        }
        this.termsPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-terms'),
            isIntChoices: true,
            defaultValue: this.model.get('termsId'),
            noneSelectedText: this.options.canEdit && this.options.isAdmin ? 'Select Value' : 'Not Selected',
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: _.bind(function (newTermsId) {
                this.model.set('termsId', newTermsId ? newTermsId : 0);
            }, this)
        });

        this.contractCompanyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contracted-company'),
            selectedContact: this.model.contractedContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: !this.model.isERPSynced() && (this.options.canEdit && this.options.isAdmin),
            hideUsers: true,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.contractedContact = selectedContact;
                this.model.set('contractedContactId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        this.invoiceContactPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contact'),
            selectedContact: this.model.invoiceContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.invoiceContact = selectedContact;
                this.model.set('invoiceContactId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.commitmentCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.commitment-custom-fields'),
                canEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        new PJQ.inputs.Datepicker({
            el: this.$('.start-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.est-complete-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('estimatedCompletionDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('estimatedCompletionDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.act-complete-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('actualCompletionDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('actualCompletionDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('contractDate', newDate);
            }, this)
        });

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER) {
            new PJQ.inputs.Datepicker({
                el: this.$('.delivery-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('deliveryDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('deliveryDate', newDate);
                }, this)
            });

            let bTo = this.model.get('billTo');
            if (bTo == null) {
                bTo = {};
            }

            if (_.size(bTo.country) === 0) {
                bTo.country = 'US';
            }

            this.billToStatePicker = new PJQ.inputs.StatePicker({
                el: this.$('.billto-state'),
                country: bTo.country,
                defaultValue: bTo.state,
                size: 20,
                onChange: (value) => {
                    let billTo = this.model.get('billTo');
                    billTo.state = value;
                    this.model.set('billTo', billTo);
                }
            });

            this.billToCountryPicker = new PJQ.inputs.CountryPicker({
                el: this.$('.billto-country'),
                defaultValue: bTo.country,
                statePicker: this.billToStatePicker,
                zipInput: this.$('.billto-zip'),
                enableInternational: this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
                size: 20,
                onChange: (value) => {
                    let billTo = this.model.get('billTo');
                    billTo.country = value;
                    this.model.set('billTo', billTo);
                }
            });

            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.billto-phone'));
            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.billto-fax'));

            let sTo = this.model.get('shipTo');
            if (sTo == null) {
                sTo = {};
            }

            if (_.size(sTo.country) === 0) {
                sTo.country = 'US';
            }

            this.shipToStatePicker = new PJQ.inputs.StatePicker({
                el: this.$('.shipto-state'),
                country: sTo.country,
                defaultValue: sTo.state,
                size: 20,
                onChange: (value) => {
                    let shipTo = this.model.get('shipTo');
                    shipTo.state = value;
                    this.model.set('shipTo', shipTo);
                }
            });

            this.shipToCountryPicker = new PJQ.inputs.CountryPicker({
                el: this.$('.shipto-country'),
                defaultValue: sTo?.country,
                statePicker: this.shipToStatePicker,
                zipInput: this.$('.shipto-zip'),
                enableInternational: this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
                size: 20,
                onChange: (value) => {
                    let shipTo = this.model.get('shipTo');
                    shipTo.country = value;
                    this.model.set('shipTo', shipTo);
                }
            });

            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.shipto-phone'));
            PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.shipto-fax'));
        }

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            new PJQ.inputs.Datepicker({
                el: this.$('.signed-contract-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('signedContractReceivedDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('signedContractReceivedDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.execution-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('executionDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('executionDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.issued-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('issuedOnDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('issuedOnDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.returned-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('returnedDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('returnedDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.letter-intent-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('letterOfIntentDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('letterOfIntentDate', newDate);
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.approval-letter-date'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('approvalLetterDate')
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('approvalLetterDate', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            let $att = this.$('.commitment-file-uploader');
            if (_.size(this.model.attachments.models) === 0 && !this.options.canUploadAttachments) {
                $att.closest('.upload-outer').hide();
            } else {
                this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $att,
                    collection: this.model.attachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.fileUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('coiAttachments')) {
            let $coi = this.$('.coi-file-uploader');
            if (_.size(this.model.coiAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $coi.closest('.upload-outer').hide();
            } else {
                this.coiUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $coi,
                    collection: this.model.coiAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.coiUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderCOIApproval();
            }
        }

        if (this.checkFieldVisible('w9Attachments')) {
            let $w9 = this.$('.w9-file-uploader');
            if (_.size(this.model.w9Attachments.models) === 0 && !this.options.canUploadAttachments) {
                $w9.closest('.upload-outer').hide();
            } else {
                this.w9Uploader = new PJQ.views.files.FileUploaderGrid({
                    el: $w9,
                    collection: this.model.w9Attachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.w9Uploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderW9Approval();
            }
        }

        if (this.checkFieldVisible('lienWaiverAttachments')) {
            let $lien = this.$('.lien-waiver-file-uploader');
            if (_.size(this.model.lienWaiverAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $lien.closest('.upload-outer').hide();
            } else {
                this.lienWaiverUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $lien,
                    collection: this.model.lienWaiverAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.lienWaiverUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
                this.renderLienWaiverApproval();
            }
        }

        if (this.checkFieldVisible('signedDocumentAttachments')) {
            let $signed = this.$('.signed-file-uploader');
            if (_.size(this.model.signedDocumentAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $signed.closest('.upload-outer').hide();
            } else {
                this.signedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $signed,
                    collection: this.model.signedDocumentAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.signedDocumentUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('affidavitAttachments')) {
            let $affidavit = this.$('.affidavit-file-uploader');
            if (_.size(this.model.affidavitAttachments.models) === 0 && !this.options.canUploadAttachments) {
                $affidavit.closest('.upload-outer').hide();
            } else {
                this.affidavitUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $affidavit,
                    collection: this.model.affidavitAttachments,
                    canUpload: this.options.canUploadAttachments,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.affidavitUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (this.checkFieldVisible('executedDocumentAttachments')) {
            let $executed = this.$('.executed-file-uploader'),
                canUpload = this.options.canUploadAttachments && this.options.isAdmin;
            if (_.size(this.model.executedDocumentAttachments.models) === 0 && !canUpload) {
                $executed.closest('.upload-outer').hide();
            } else {
                this.executedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                    el: $executed,
                    collection: this.model.executedDocumentAttachments,
                    canUpload: canUpload,
                    useApiV2: true,
                    canView: false,
                    canDelete: this.options.isAdmin,
                    previewImageDimension: 150,
                    onSuccess: _.bind(function (file) {
                        this.model.isDirty = true;
                        this.executedDocumentUploader.clearError();
                    }, this),
                    onDelete: _.bind(function (attachment, callback) {
                        if (attachment.get('id') > 0) {
                            attachment.set('delete', true);
                        } else {
                            attachment.destroy();
                        }

                        this.model.isDirty = true;
                        callback();
                    }, this)
                });
            }
        }

        if (_.size(this.uploadCustomFields) > 0) {
            this.renderUploadCustomFields();
        }
    },
    renderUploadCustomFields: function () {
        this.customFieldUploaders = [];
        _.each(this.uploadCustomFields, function (field) {
            let type = 'cf-' + field.id,
                $upload = this.$("." + type + '-file-uploader'),
                canUpload = this.options.canUploadAttachments && (!field.get('isAdminEdit') || this.options.isAdmin),
                customFieldAttachments = _.filter(this.model.customFieldAttachments.models, function (attachment) {
                    return attachment.get('type') === type;
                });

            if (_.size(customFieldAttachments) === 0 && !canUpload) {
                $upload.closest('.upload-outer').hide();
                return;
            }

            let attachmentsCollection = new PJQ.collections.commitments.CommitmentAttachments(customFieldAttachments);
            let uploader = new PJQ.views.files.FileUploaderGrid({
                el: $upload,
                collection: attachmentsCollection,
                canUpload: canUpload,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                    uploader.clearError();

                    let newAttachment = _.find(attachmentsCollection.models, function (attachment) {
                        return attachment.get('uploadId') === file.uploadId;
                    });

                    if (newAttachment != null) {
                        newAttachment.set('type', type);
                        this.model.customFieldAttachments.add(newAttachment);
                    }
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({id: attachment.get('id')});

                        attachment.set('delete', true);
                        if (customFieldAttachment != null) {
                            customFieldAttachment.set('delete', true);
                        }
                    } else {
                        let customFieldAttachment = this.model.customFieldAttachments.findWhere({uploadId: attachment.get('uploadId')});

                        attachment.destroy();
                        if (customFieldAttachment != null) {
                            this.model.customFieldAttachments.remove(customFieldAttachment);
                        }
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.customFieldUploaders.push(uploader);
        }, this);
    },
    renderCOIApproval: function () {
        if (this.coiApproval != null) {
            this.coiApproval.remove();
        }
        if (this.model.get('isCOIRequired')) {
            this.coiApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.coi-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isCOIApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isCOIApproved', value);
                }, this)
            });
        }
    },
    renderW9Approval: function () {
        if (this.w9Approval != null) {
            this.w9Approval.remove();
        }
        if (this.model.get('isW9Required')) {
            this.w9Approval = new PJQ.inputs.ButtonGroup({
                el: this.$('.w9-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isW9Approved'),
                onChange: _.bind(function (value) {
                    this.model.set('isW9Approved', value);
                }, this)
            });
        }
    },
    renderLienWaiverApproval: function () {
        if (this.lienWaiverApproval != null) {
            this.lienWaiverApproval.remove();
        }
        if (this.model.get('isLienWaiverRequired')) {
            this.lienWaiverApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.lien-waiver-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isLienWaiverApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isLienWaiverApproved', value);
                }, this)
            });
        }
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    renderLineItems() {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.commitment-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.commitments.CommitmentLineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            canChangeAccountingMethod: this.options.isSubmitting || this.options.canEditLineItems,
            financialMarkups: this.model.markupItems,
            enableTax: true,
            billedToDate: this.options.canViewInvoices && this.model.invoices != null ? () => {
                let res = 0;
                _.each(this.model.invoices.models, function (invoice) {
                    if (invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED
                        || invoice.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
                        res += invoice.getGrandTotal();
                    }
                });
                return res;
            } : null,
            showBilling: this.model.get('statusId') === PJQ.constants.commitments.commitmentStatus.APPROVED || this.model.get('statusId') === PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE,
            approvedChanges: this.model.get('approvedChanges'),
            onApprovedChangesClicked: () => {
                this.activateView(this.views.CHANGEORDERS);
            },
            onBilledToDateClicked: () => {
                this.activateView(this.views.INVOICES);
            },
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.updateCounts();
            }, this)
        });
    },
    copyToHelper: function (e) {
        let from = $(e.currentTarget).data('from'),
            to = $(e.currentTarget).data('to'),
            contact = {},
            fromDescription = '',
            toDescription = '',
            fnContinue = () => {
                new PJQ.views.modals.YesNo({
                    header: 'Copy to ' + toDescription,
                    body: 'Are you sure you want to overwrite the ' + toDescription + ' based on the ' + fromDescription + '?',
                    onYes: _.bind(function () {

                        this.model.attributes[to].companyName = contact.companyName;
                        this.model.attributes[to].contactName = contact.contactName;
                        this.model.attributes[to].address1 = contact.address1;
                        this.model.attributes[to].address2 = contact.address2;
                        this.model.attributes[to].city = contact.city;
                        this.model.attributes[to].state = contact.state;
                        this.model.attributes[to].zip = contact.zip;
                        this.model.attributes[to].country = contact.country;
                        this.model.attributes[to].phone = contact.phone;
                        this.model.attributes[to].fax = contact.fax;
                        this.model.attributes[to].email = contact.email;

                        this.$('.' + to.toLowerCase() + '-companyname').val(contact.companyName);
                        this.$('.' + to.toLowerCase() + '-contactname').val(contact.contactName);
                        this.$('.' + to.toLowerCase() + '-address1').val(contact.address1);
                        this.$('.' + to.toLowerCase() + '-address2').val(contact.address2);
                        this.$('.' + to.toLowerCase() + '-city').val(contact.city);
                        this.$('.' + to.toLowerCase() + '-phone').val(contact.phone);
                        this.$('.' + to.toLowerCase() + '-fax').val(contact.fax);
                        this.$('.' + to.toLowerCase() + '-email').val(contact.email);

                        if (to === 'billTo')
                            this.billToCountryPicker.setValue(contact.country);
                        else if (to === 'shipTo')
                            this.shipToCountryPicker.setValue(contact.country);

                        if (to === 'billTo')
                            this.billToStatePicker.setValue(contact.state);
                        else if (to === 'shipTo')
                            this.shipToStatePicker.setValue(contact.state);

                        this.$('.' + to.toLowerCase() + '-zip').val(contact.zip);
                    }, this),
                });
            };

        switch (from) {
            case 'shipTo':
                fromDescription = 'Ship To';
                contact.companyName = this.$('.shipto-companyname').val();
                contact.contactName = this.$('.shipto-contactname').val();
                contact.address1 = this.$('.shipto-address1').val();
                contact.address2 = this.$('.shipto-address2').val();
                contact.city = this.$('.shipto-city').val();
                contact.state = this.shipToStatePicker.getValue().toUpperCase();
                contact.zip = this.$('.shipto-zip').val();

                let sCountry = this.shipToCountryPicker.getValue().toUpperCase();
                contact.country = _.size(sCountry) === 0 ? 'US' : sCountry;
                contact.phone = this.$('.shipto-phone').val();
                contact.fax = this.$('.shipto-fax').val();
                contact.email = this.$('.shipto-email').val();
                break;
            case 'billTo':
                fromDescription = 'Bill To';
                contact.companyName = this.$('.billto-companyname').val();
                contact.contactName = this.$('.billto-contactname').val();
                contact.address1 = this.$('.billto-address1').val();
                contact.address2 = this.$('.billto-address2').val();
                contact.city = this.$('.billto-city').val();
                contact.state = this.billToStatePicker.getValue().toUpperCase();
                contact.zip = this.$('.billto-zip').val();

                let bCountry = this.billToCountryPicker.getValue().toUpperCase();
                contact.country = _.size(bCountry) === 0 ? 'US' : bCountry;
                contact.phone = this.$('.billto-phone').val();
                contact.fax = this.$('.billto-fax').val();
                contact.email = this.$('.billto-email').val();
                break;
            case 'project':
                fromDescription = 'Project';
                contact.address1 = PJQ.app.session.project.get('address1');
                contact.address2 = PJQ.app.session.project.get('address2');
                contact.city = PJQ.app.session.project.get('city');
                contact.state = PJQ.app.session.project.get('state');
                contact.zip = PJQ.app.session.project.get('zip');
                contact.country = PJQ.app.session.project.get('country');
                break;
        }

        switch (to) {
            case 'shipTo':
                toDescription = 'Ship To';
                break;
            case 'billTo':
                toDescription = 'Bill To';
                break;
        }

        if (from === 'addressBook') {
            fromDescription = 'Address Book';

            new PJQ.views.contacts.SelectContactsModal({
                context: PJQ.constants.contacts.contexts.CONTACTS,
                isSingleChoice: true,
                onSave: _.bind(function (data) {
                    contact.companyName = data.get('companyName');
                    contact.contactName = data.get('contactName');
                    contact.address1 = data.get('address1');
                    contact.address2 = data.get('address2');
                    contact.city = data.get('city');
                    contact.state = data.get('state');
                    contact.zip = data.get('zip');

                    let country = data.get('country');
                    contact.country = _.size(country) === 0 ? 'US' : country;
                    contact.phone = data.get('phone');
                    contact.fax = data.get('fax');
                    contact.email = data.get('email');

                    fnContinue();
                }, this)
            });
        } else
            fnContinue();
    },
    renderChangeOrders: function () {
        if (this.model.isNew()) {
            return;
        }

        this.changeOrdersDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitment-change-orders'),
            data: this.model.changeOrders.models,
            isHideSearch: true,
            language: {
                emptyTable: this.options.canAddChangeOrders ? 'Click "New Change Order" to create a Commitment Change Order' : 'No change orders have been created'
            },
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewChangeOrders;
                        }, this)
                    }
                ]
            },
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                }, {
                    "data": "attributes.number",
                    "title": "Number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return data;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                    }, this)
                }, {
                    "data": "attributes.description",
                    "title": "Description",
                }, {
                    "columnData": "createdOn",
                    "data": "attributes.createdOn",
                    "title": 'Created',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }, this)
                }, {
                    "data": "attributes.invoicedDate",
                    "title": 'Invoiced Date',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        if (_.size(row.get('invoicedDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }, this)
                }, {
                    "data": "attributes.dueDate",
                    "title": 'Due Date',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        if (_.size(row.get('dueDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('dueDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }, this)
                }, {
                    "data": "attributes.statusId",
                    "title": "Status",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')];
                    }, this)
                }, {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (changeOrder) {
                            amt += changeOrder.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                }, {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewChangeOrders) {
                            html += '<button type="button" class="btn btn-info btn-view-change-order ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this)
        });
    },
    newChangeOrder: function () {
        this.viewChangeOrder();
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewChangeOrderClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.changeOrdersDataTable.getRow(target.closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        this.removeModal();
        new PJQ.views.commitments.ChangeOrderEditModal({
            commitment: this.model,
            model: changeOrder,
            onSave: _.bind(function (changeOrder, isNew) {
                if (isNew) {
                    this.model.changeOrders.add(changeOrder);
                    this.changeOrdersDataTable.addRow(changeOrder);

                    if (typeof this.options.onChangeOrderAdd === 'function') {
                        this.options.onChangeOrderAdd(changeOrder);
                    }
                } else {
                    this.changeOrdersDataTable.refresh();
                }
                this.model.set('changeOrders', this.model.changeOrders.toJSON());
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function (changeOrderId) {
                this.changeOrdersDataTable.render();
                this.model.set('changeOrders', this.model.changeOrders.toJSON());

                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deleteChangeOrder: function (changeOrder) {
        let row = this.changeOrdersDataTable.getRow(changeOrder.cid),
            changeOrderId = row.data().id;
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Change Order",
            body: "Are you sure you want to delete this change order?",
            onDelete: _.bind(function () {
                this.model.changeOrders.remove(changeOrder);
                this.model.set('changeOrders', this.model.changeOrders.toJSON());
                changeOrder.destroy({
                    success: _.bind(function () {
                        this.changeOrdersDataTable.removeRow(row);

                        if (typeof this.options.onChangeOrderDelete === 'function') {
                            this.options.onChangeOrderDelete(changeOrderId);
                        }
                        this.updateCounts();
                    }, this)
                });
            }, this)
        });
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            isPayable: true,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    let invoice = this.model.invoices.get(payment.get('invoiceId'));
                    if (invoice != null) {
                        invoice.payments.add(payment);
                    }

                    this.paymentsDataTable.addRow(invoice);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
        });
    },
    renderPayments: function () {
        if (this.model.isNew() || !this.invoiceSettings.get('enablePayments')) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.c-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    if (row.isERPSynced()) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                    return '';
                }
            },
                {
                    "title": "#",
                    "data": "attributes.number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                    }, this)
                },
                {
                    "title": "Check #",
                    "data": "attributes.checkNumber"
                },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "title": "Payment Method",
                    "data": "attributes.paymentMethod",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoicing.paymentMethods.find(item => item.toLowerCase() === data.toLowerCase()) ?? '';
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (payment) {
                            amt += payment.get('amount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    viewInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.invoicesDataTable.getRow(target.closest('tr'));
        this.viewInvoice(row.data());
    },
    viewInvoice: function (invoice) {
        this.removeModal();
        new PJQ.views.invoicing.EditPayableInvoiceModal({
            commitment: this.model,
            model: invoice,
            onSave: _.bind(function (invoice, isNew) {
                if (isNew) {
                    this.model.invoices.add(invoice);
                    this.invoicesDataTable.addRow(invoice);

                    if (typeof this.options.onInvoiceAdd === 'function') {
                        this.options.onInvoiceAdd(invoice);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deleteInvoice: function (invoice) {
        let row = this.invoicesDataTable.getRow(invoice.cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Invoice?",
            onDelete: _.bind(function () {
                invoice.destroy({
                    success: _.bind(function () {
                        this.invoicesDataTable.removeRow(row);
                        this.updateCounts();

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }
                    }, this)
                });
            }, this)
        });
    },
    renderInvoices: function () {
        if (this.model.isNew()) {
            return;
        }

        this.invoicesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitment-invoices'),
            data: this.model.invoices.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Invoices have been created yet',
                zeroRecords: "No Invoices matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                }, {
                    "title": "#",
                    "data": "attributes.number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-invoice">' + data + '</a>'
                    }, this)
                },
                {
                    "title": 'Billing Period',
                    "data": "",
                    "width": '90px',
                    "render": _.bind(function (data, type, row) {
                        let periodStart = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                            periodEnd = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);

                        return (periodStart) + ' - ' + (periodEnd);
                    }, this)
                },
                {
                    "title": 'Due Date',
                    "data": "",
                    "width": '90px',
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('billingDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "data": "",
                    "title": "Status",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoicing.payableInvoiceStatusNames[row.get('statusId')]
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Retainage",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getRetainage();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        // if (PJQ.app.session.project.hasPermission('payableInvoices.isAdmin')) {
                        //     html += '<button type="button" class="btn btn-danger delete-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                        // }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                let invoice = row.data();
                if (invoice != null && this.options.canViewInvoices) {
                    invoice.fetch({
                        success: _.bind(function () {
                            this.viewInvoice(invoice);
                        }, this)
                    });
                }
            }, this)
        });
    },
    validate: function () {
        let isValid = true;
        PJQ.helpers.inputHelpers.setInputError(this.$('.commitment-number, .commitment-title'), true);

        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.commitment-number'), false);
        }

        if (!this.contractCompanyPicker.validate()) {
            isValid = false;
        }

        if (this.commitmentCustomFieldsForm != null && !this.commitmentCustomFieldsForm.validate())
            isValid = false;

        if (this.checkFieldRequired('invoiceContactId')) {
            if (!this.invoiceContactPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultWorkRetainagePercent')) {
            let $workRetainage = this.$('.default-work-retainage');
            PJQ.helpers.inputHelpers.setInputError($workRetainage, true);
            if (this.model.get('defaultWorkRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($workRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultMaterialRetainagePercent')) {
            let $materialRetainage = this.$('.default-material-retainage');
            PJQ.helpers.inputHelpers.setInputError($materialRetainage, true);
            if (this.model.get('defaultMaterialRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($materialRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('termsId')) {
            let $terms = this.$('.select-terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (this.model.get('termsId') == null || this.model.get('termsId') === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.commitment-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedDocumentAttachments')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('affidavitAttachments')) {
            this.affidavitUploader.clearError();
            let hasValidAttachment = _.find(this.model.affidavitAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.affidavitUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedDocumentAttachments')) {
            this.executedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.executedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.executedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            if (this.checkFieldRequired('startDate')) {
                let $startDate = this.$('.start-date');
                PJQ.helpers.inputHelpers.setInputError($startDate, true);
                if (this.model.get('startDate') == null || this.model.get('startDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($startDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('estimatedCompletionDate')) {
                let $estimatedCompletionDate = this.$('.est-complete-date');
                PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, true);
                if (this.model.get('estimatedCompletionDate') == null || this.model.get('estimatedCompletionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('actualCompletionDate')) {
                let $actualCompletionDate = this.$('.act-complete-date');
                PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, true);
                if (this.model.get('actualCompletionDate') == null || this.model.get('actualCompletionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('contractDate')) {
                let $contractDate = this.$('.contract-date');
                PJQ.helpers.inputHelpers.setInputError($contractDate, true);
                if (this.model.get('contractDate') == null || this.model.get('contractDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($contractDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('signedContractReceivedDate')) {
                let $signedContractDate = this.$('.signed-contract-date');
                PJQ.helpers.inputHelpers.setInputError($signedContractDate, true);
                if (this.model.get('signedContractReceivedDate') == null || this.model.get('signedContractReceivedDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($signedContractDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('letterOfIntentDate')) {
                let $letterOfIntentDate = this.$('.letter-intent-date');
                PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, true);
                if (this.model.get('letterOfIntentDate') == null || this.model.get('letterOfIntentDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('approvalLetterDate')) {
                let $approvalLetterDate = this.$('.approval-letter-date');
                PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, true);
                if (this.model.get('approvalLetterDate') == null || this.model.get('approvalLetterDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('issuedOnDate')) {
                let $issuedOnDate = this.$('.issued-date');
                PJQ.helpers.inputHelpers.setInputError($issuedOnDate, true);
                if (this.model.get('issuedOnDate') == null || this.model.get('issuedOnDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($issuedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('executionDate')) {
                let $executedOnDate = this.$('.execution-date');
                PJQ.helpers.inputHelpers.setInputError($executedOnDate, true);
                if (this.model.get('executionDate') == null || this.model.get('executionDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($executedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('returnedDate')) {
                let $returnedOnDate = this.$('.returned-date');
                PJQ.helpers.inputHelpers.setInputError($returnedOnDate, true);
                if (this.model.get('returnedDate') == null || this.model.get('returnedDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($returnedOnDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('inclusions')) {
                let $inclusions = this.$('.inclusions');
                PJQ.helpers.inputHelpers.setInputError($inclusions, true);
                if (_.size(this.model.get('inclusions')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($inclusions, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('exclusions')) {
                let $exclusions = this.$('.exclusions');
                PJQ.helpers.inputHelpers.setInputError($exclusions, true);
                if (_.size(this.model.get('exclusions')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($exclusions, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('coiAttachments')) {
                this.coiUploader.clearError();
                let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.coiUploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('w9Attachments')) {
                this.w9Uploader.clearError();
                let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.w9Uploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('lienWaiverAttachments')) {
                this.lienWaiverUploader.clearError();
                let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                    return !model.get('delete')
                }, this) != null;

                if (!hasValidAttachment) {
                    this.lienWaiverUploader.showError('Missing attachment', 100000);
                    isValid = false;
                }
            }
        } else {
            if (this.checkFieldRequired('deliveryDate')) {
                let $deliveryDate = this.$('.delivery-date');
                PJQ.helpers.inputHelpers.setInputError($deliveryDate, true);
                if (this.model.get('deliveryDate') == null || this.model.get('deliveryDate').length === 0) {
                    PJQ.helpers.inputHelpers.setInputError($deliveryDate, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('paymentTerms')) {
                let $paymentTerms = this.$('.payment-terms');
                PJQ.helpers.inputHelpers.setInputError($paymentTerms, true);
                if (_.size(this.model.get('paymentTerms')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($paymentTerms, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('shipVia')) {
                let $shipVia = this.$('.ship-via');
                PJQ.helpers.inputHelpers.setInputError($shipVia, true);
                if (_.size(this.model.get('shipVia')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($shipVia, false);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('shipToId')) {
                let $shipToCompany = this.$('.shipto-companyname'),
                    $shipToContact = this.$('.shipto-contactname'),
                    $shipToAddress1 = this.$('.shipto-address1'),
                    $shipToCity = this.$('.shipto-city'),
                    $shipToZip = this.$('.shipto-zip');
                PJQ.helpers.inputHelpers.setInputError($shipToCompany, true);
                PJQ.helpers.inputHelpers.setInputError($shipToContact, true);
                PJQ.helpers.inputHelpers.setInputError($shipToAddress1, true);
                PJQ.helpers.inputHelpers.setInputError($shipToCity, true);
                PJQ.helpers.inputHelpers.setInputError($shipToZip, true);

                if (_.size(this.model.get('shipTo').companyName) === 0 ||
                    _.size(this.model.get('shipTo').contactName) === 0 ||
                    _.size(this.model.get('shipTo').address1) === 0 ||
                    _.size(this.model.get('shipTo').city) === 0 ||
                    _.size(this.model.get('shipTo').zip) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($shipToCompany, _.size(this.model.get('shipTo').companyName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToContact, _.size(this.model.get('shipTo').contactName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToAddress1, _.size(this.model.get('shipTo').address1) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToCity, _.size(this.model.get('shipTo').city) > 0);
                    PJQ.helpers.inputHelpers.setInputError($shipToZip, _.size(this.model.get('shipTo').zip) > 0);
                    isValid = false;
                }
            }

            if (this.checkFieldRequired('billToId')) {
                let $billToCompany = this.$('.billto-companyname'),
                    $billToContact = this.$('.billto-contactname'),
                    $billToAddress1 = this.$('.billto-address1'),
                    $billToCity = this.$('.billto-city'),
                    $billToZip = this.$('.billto-zip');
                PJQ.helpers.inputHelpers.setInputError($billToCompany, true);
                PJQ.helpers.inputHelpers.setInputError($billToContact, true);
                PJQ.helpers.inputHelpers.setInputError($billToAddress1, true);
                PJQ.helpers.inputHelpers.setInputError($billToCity, true);
                PJQ.helpers.inputHelpers.setInputError($billToZip, true);

                if (_.size(this.model.get('billTo').companyName) === 0 ||
                    _.size(this.model.get('billTo').contactName) === 0 ||
                    _.size(this.model.get('billTo').address1) === 0 ||
                    _.size(this.model.get('billTo').city) === 0 ||
                    _.size(this.model.get('billTo').zip) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($billToCompany, _.size(this.model.get('billTo').companyName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToContact, _.size(this.model.get('billTo').contactName) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToAddress1, _.size(this.model.get('billTo').address1) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToCity, _.size(this.model.get('billTo').city) > 0);
                    PJQ.helpers.inputHelpers.setInputError($billToZip, _.size(this.model.get('billTo').zip) > 0);
                    isValid = false;
                }
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;
            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    save: function (callback) {
        if (this.model.get('commitmentType') === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER && this.options.canEdit) {
            let billTo = this.model.get('billTo') ? this.model.get('billTo') : {};
            billTo.companyName = this.$('.billto-companyname').val();
            billTo.contactName = this.$('.billto-contactname').val();
            billTo.address1 = this.$('.billto-address1').val();
            billTo.address2 = this.$('.billto-address2').val();
            billTo.city = this.$('.billto-city').val();
            billTo.zip = this.$('.billto-zip').val();
            billTo.phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.billto-phone').val());
            billTo.fax = PJQ.helpers.formatHelpers.numbersOnly(this.$('.billto-fax').val());
            billTo.email = this.$('.billto-email').val();
            this.model.set('billTo', billTo);

            let shipTo = this.model.get('shipTo') ? this.model.get('shipTo') : {};
            shipTo.companyName = this.$('.shipto-companyname').val();
            shipTo.contactName = this.$('.shipto-contactname').val();
            shipTo.address1 = this.$('.shipto-address1').val();
            shipTo.address2 = this.$('.shipto-address2').val();
            shipTo.city = this.$('.shipto-city').val();
            shipTo.zip = this.$('.shipto-zip').val();
            shipTo.phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.shipto-phone').val());
            shipTo.fax = PJQ.helpers.formatHelpers.numbersOnly(this.$('.shipto-fax').val());
            shipTo.email = this.$('.shipto-email').val();
            this.model.set('shipTo', shipTo);
        }

        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.set('customFields', this.commitmentCustomFieldsForm != null ? this.commitmentCustomFieldsForm.getChanged() : null);

        this.model.save({
            assignedTo: this.assignedTo,
            invoiceContact: this.invoiceContact,
            lineItems: this.model.lineItems.models
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('commitmentChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: (data) => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: data.responseJSON.error
                });
            }
        });

        return true;
    },
    deleteCommitment: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this commitment?  All associated change orders and invoices will also be deleted.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Commitment deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment saved successfully'
                });
                this.email();
            }
        });
    },
    saveCommitment: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment saved successfully'
                });

                this.removeModal();
            }
        });
    },
    validateForSubmit: function () {
        let isValid = true,
            scrollEl = null;
        if (this.model.get('isCOIRequiredForSubmit')) {
            this.coiUploader.clearError();
            let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.coiUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.coiUploader.$el[0];
            }
        }

        if (this.model.get('isW9RequiredForSubmit')) {
            this.w9Uploader.clearError();
            let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.w9Uploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.w9Uploader.$el[0];
            }
        }

        if (this.model.get('isLienWaiverRequiredForSubmit')) {
            this.lienWaiverUploader.clearError();
            let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.lienWaiverUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.lienWaiverUploader.$el[0];
            }
        }

        if (this.model.get('isSignedDocumentsRequiredForSubmit')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.signedDocumentUploader.$el[0];
            }
        }

        if (this.model.get('isAffidavitRequiredForSubmit')) {
            this.affidavitUploader.clearError();
            let hasValidAttachment = _.find(this.model.affidavitAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.affidavitUploader.showError('Missing attachment', 100000);
                isValid = false;

                scrollEl = scrollEl || this.affidavitUploader.$el[0];
            }
        }

        if (scrollEl != null && typeof scrollEl.scrollIntoView === 'function') {
            scrollEl.scrollIntoView();
        }

        return isValid;
    },
    submitForReview: function () {
        if (!this.validateForSubmit()) {
            return;
        }

        this.model.submit((result) => {
            if (result) {
                this.options.project.trigger('commitmentChanged', this.model);

                PJQ.notifications.notify.successNotify({
                    message: 'Commitment submitted successfully'
                });

                this.removeModal();
            }
        });
    },
    signAndSubmit: function () {
        if (!this.validateForSubmit()) {
            return;
        }

        new PJQ.views.signatures.SignatureSubmitModal({
            onSubmit: (signature, callback) => {
                this.model.set('signature', signature);
                this.model.submit(() => {
                    this.options.project.trigger('commitmentChanged', this.model);

                    this.render();
                    callback();

                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment signed & submitted successfully'
                    });
                });
            }
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Commitment has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: "Email Commitment",
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment email sent'
                    });
                }, this));
            }, this)
        });
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.c-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditLineItems,
            canVoid: true
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || false === this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS)) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let canPush = true,
            disablePushReason = "",
            fnRenderButtons = _.bind(function () {
                PJQ.helpers.erp.renderERPButtons($erp, {
                    status: this.model.erpSyncStatus(),
                    pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS),
                    canPush: canPush,
                    canPushChanges: false,
                    disablePushReason: disablePushReason,
                    unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_COMMITMENTS),
                });
            }, this);

        if (_.size(this.model.lineItems.models) === 0
            || (this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.APPROVED
                && this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_COMPLETE
                && this.model.get('statusId') !== PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED)) {
            canPush = false;
            disablePushReason = "Commitment must be approved or complete and have line items";
        }

        let canPushWithoutVendorSynced = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS_WITH_VENDOR);
        if (this.model.contractedContact && !canPushWithoutVendorSynced) {
            this.model.contractedContact.fetchCompanyERPObject(_.bind(function (erpObject) {
                if (!erpObject || _.size(erpObject.externalId) === 0) {
                    canPush = false;
                    disablePushReason = "Contracted Company must be synced to ERP before this commitment can be pushed";
                }
                fnRenderButtons();
            }, this));
        } else {
            fnRenderButtons();
        }
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMMITMENTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushCommitment(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Commitment pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitment removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Commitment from your ERP system?  This will also unlink all Change Orders and Invoices associated with it.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkCommitment(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Commitment unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    viewHistory: async function () {
        let cType = PJQ.constants.commitments.commitmentTypeNames[this.model.get('commitmentType')],
            historyItems = [{
                date: this.model.get('createdOn'),
                person: this.model.get('createdBy'),
                action: cType + ' Created'
            }];

        let history = new PJQ.collections.commitments.History({}, {
            commitmentId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: cType + ' #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportCommitment: function () {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'commitments',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveCommitment();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});